export default __webpack_public_path__ + "static/media/trash.ef31db03.svg";